import { createContext, useState } from "react";

export const ModeContext = createContext({
    mode: false,
    setMode: () => { },
})


export const ModeProvider = ({children}) => {
    const [mode, setMode] = useState(false);

    const value = {
        mode,
        setMode
    }
    
    return <ModeContext.Provider value={value}>{ children}</ModeContext.Provider>
}